import withFeatureTests from './FeatureTestContext';

export default withFeatureTests;
